import type { BacklogRequestOption } from "../contracts/api/BacklogRequestOption";
import { BacklogError } from "./BacklogError";

export class BacklogApiAbortError extends BacklogError {
	public readonly url: string | URL;
	public readonly options: BacklogRequestOption;

	constructor(options: {
		readonly url: string | URL;
		readonly options: BacklogRequestOption;
	}) {
		super("BacklogApiAbortError");
		this.url = options.url;
		this.options = options.options;
	}
}
